import { SvgIcon } from '@mui/material';
import { styled } from '@mui/material/styles';
import _ from 'lodash';

enum FontSize {
	inherit = 'inherit',
	small = '1rem',
	medium = '1.5rem',
	large = '2rem'
}

const Styled = (Icon: typeof SvgIcon) =>
	styled(Icon)(({ fontSize, width, theme: { palette }, color }) => {
		const themeColor = _.get(palette, color as string)

		return {
			fill: '#fff0',
			...(fontSize && {
				fontSize: `${Number(fontSize) ? fontSize+'rem' : FontSize[fontSize as keyof typeof FontSize]} !important`
			}),
			...(width && {
				width,
				height: width
			}),
			color: themeColor || 'inherit'
		};
	});

export { Styled };
export default Styled;
